export default "__VITE_ASSET__kYedWW3E__"